import { render, staticRenderFns } from "./ObtainCourseCertificateButtons.vue?vue&type=template&id=418d2f7d&scoped=true"
import script from "./ObtainCourseCertificateButtons.vue?vue&type=script&lang=js"
export * from "./ObtainCourseCertificateButtons.vue?vue&type=script&lang=js"
import style0 from "./ObtainCourseCertificateButtons.vue?vue&type=style&index=0&id=418d2f7d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "418d2f7d",
  null
  
)

export default component.exports